module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "EquityVipView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EquityVipView!./src/pages/Promote/Equity/EquityVipView/index.js
// module id = 1114
// module chunks = 438